var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import cxs from 'cxs/component';
import Theme from 'Theme';
var Loading = /** @class */ (function (_super) {
    __extends(Loading, _super);
    function Loading() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Loading.prototype.render = function () {
        return React.createElement(Spinner, __assign({}, this.props));
    };
    return Loading;
}(Component));
export default Loading;
var SpinnerStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    // display: 'inline-block',
    width: '30px',
    height: '30px',
    marginTop: '-15px',
    marginLeft: '-15px',
    borderRadius: '50%',
    border: "2px solid ".concat(Theme.color.hairline),
    borderTopColor: Theme.color.primary,
    animation: "spinner .7s ease-in-out infinite",
    // boxShadow: '0 0 10px white',
    // opacity: 1,
    zIndex: 100,
};
var Spinner = cxs('div')(SpinnerStyle);
export var spinner = {
    ':before': __assign(__assign({}, SpinnerStyle), { content: '""' })
};
export var loading = function (promises) { return function (DecoratedComponent) {
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.state = {
                values: undefined
            };
            _this.handleReload = function () {
                _this.setState({ values: null });
                Promise.all(promises(_this.props)).then(function (results) {
                    _this.setState({
                        values: results.reduce(function (values, value) {
                            if (typeof value === 'object')
                                Object.assign(values, value);
                            return values;
                        }, {})
                    });
                });
            };
            return _this;
        }
        class_1.prototype.componentWillMount = function () {
            this.handleReload();
        };
        class_1.prototype.render = function () {
            var values = this.state.values;
            if (values)
                return React.createElement(DecoratedComponent, __assign({ reload: this.handleReload }, this.props, values));
            return React.createElement(Loading, null);
        };
        return class_1;
    }(Component));
}; };



//////////////////
// WEBPACK FOOTER
// ./src/elements/Loading.tsx
// module id = 12
// module chunks = 0